var en_CA = {};
module['exports'] = en_CA;
en_CA.title = "English (Canada)";
en_CA.address = require("./address");
en_CA.internet = require("./internet");
en_CA.phone_number = require("./phone_number");